export default function SearchSummary({ result, onClose }) {
  if (!result) return null;

  const sections = [
    { label: 'Key Trends', key: 'key_trends' },
    { label: 'Common Methods', key: 'common_methods' },
    { label: 'Design Decisions', key: 'design_decisions' },
    { label: 'Research Gaps', key: 'research_gaps' },
  ];

  return (
    <div
      className="bg-white rounded-lg p-5 mb-4"
      style={{ boxShadow: 'rgba(0,0,0,0.08) 0px 0px 0px 1px, rgba(0,0,0,0.04) 0px 2px 2px' }}
    >
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="font-semibold text-[#171717] text-sm" style={{ letterSpacing: '-0.32px' }}>
            Search Summary: <span className="text-[#4d4d4d]">"{result.query}"</span>
          </h3>
          <p className="text-xs text-[#808080] mt-0.5">AI-extracted trends and design decisions across all results</p>
        </div>
        <button
          onClick={onClose}
          className="text-[#808080] hover:text-[#171717] text-xl leading-none transition-colors"
        >
          &times;
        </button>
      </div>

      {result.mock_mode && (
        <div className="mb-3 rounded px-3 py-1.5 text-xs text-amber-700 font-medium bg-amber-50" style={{ boxShadow: 'rgba(251,191,36,0.3) 0px 0px 0px 1px' }}>
          MOCK MODE — Add ANTHROPIC_API_KEY for real AI summarization
        </div>
      )}

      <div className="grid grid-cols-2 gap-3">
        {sections.map(({ label, key }) => (
          <div
            key={key}
            className="rounded-lg p-3"
            style={{ boxShadow: 'rgba(0,0,0,0.08) 0px 0px 0px 1px' }}
          >
            <div className="flex items-center gap-1.5 mb-2">
              <span className="text-xs font-semibold text-[#4d4d4d] uppercase tracking-wide">{label}</span>
            </div>
            <ul className="space-y-1.5">
              {result[key].map((item, i) => (
                <li key={i} className="text-xs text-[#4d4d4d] leading-relaxed flex gap-1.5">
                  <span className="text-[#808080] mt-0.5 flex-shrink-0">·</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
